import Interieur from "./Interieur.js";
import Brett from "./Brett.js";

export default class Konstruktionsboden extends Interieur {
    // DO NOT CHANGE
    // needs to be 'Brett', NCAD can't handle 'Konstruktionsboden
    className = "Brett";

    fromJSON(json) {
        super.fromJSON(json);
        this.isDropped = true;
        return this;
    }

    toJSON() {
        const json = super.toJSON();
        json.className = this.className;
        return json
    }
    compileSizeAndBox() {
        super.compileSizeAndBox();
        this.size.y = this.schrank.options.getFloat('brett_staerke');
    }

    compileInternals() {
        super.compileInternals();
        if (!this.brett) {
            this.brett = new Brett(this, 'Konstruktionsboden', 'xz');
            this.brett.inSketch = true;
            this.brett.isInner = true;
        }
        this.brett.box = this.boxLocal.clone();
        this.brett.box.max.z -= this.schrank.options.getFloat('aussenwand_vorsprung');
        this.brett.boxToVertices();
        this.brett.compile();
    }

    iterate(iterator) {
        super.iterate(iterator);
        iterator(this.brett);
    }
}